module.exports = __webpack_public_path__ + "media/favicon/apple-touch-icon-9885d73c2141f1bacb6e15c0ecc3a9b9.png";